import Stack from '@mui/material/Stack';
import { Box } from '@mui/system';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useConfig } from '@/modules/common/hooks';

import PackageVersionChip from './PackageVersionChip';

type Version = {
  dt: string;
  ftLib: string;
  ftWebGl: string;
  ftAsset: string;
};

const defaultVersion: Version = {
  dt: '?',
  ftLib: '?',
  ftWebGl: '?',
  ftAsset: '?',
};

export default function VersionList() {
  const { app } = useConfig();
  const [version, setVersion] = useState<Version>(defaultVersion);
  const { t } = useTranslation('common');

  useEffect(() => {
    if (!app?.version) return;

    axios.get(`/package-lock.json?${app.version}`).then((res) => {
      const packages = res.data?.packages;
      if (!packages) return;

      setVersion({
        ftAsset: packages?.['node_modules/@thive/fleet-tracker.asset']?.version,
        ftWebGl: packages?.['node_modules/@thive/fleet-tracker.web-gl']?.version,
        ftLib: packages?.['node_modules/@thive/fleet-tracker.web-gl.react']?.version,
        dt: app.version,
      });
    });
  }, [app?.version]);

  return (
    <Stack direction='column'>
      <Stack direction='row' marginBottom={1}>
        <Box flexGrow={1}>{t('version', 'Version')}</Box>
        <Box>{version.dt}</Box>
      </Stack>
      <Stack direction='row' flexWrap='wrap'>
        <PackageVersionChip name='FT.Lib' version={version.ftLib} />
        <PackageVersionChip name='FT.WebGL' version={version.ftWebGl} />
        <PackageVersionChip name='FT.Asset' version={version.ftAsset} />
      </Stack>
    </Stack>
  );
}
